<template>
  <div class="cf-AdvanceSettings-Wrap">
    <div></div>
    <mds-layout-grid>
      <mds-row>
        <template>
          <div
            class="cf-heading-align cf-headingSingle"
            v-if="singleHeading !== ''"
          >
            {{ singleHeading }}
          </div>

          <div v-if="singleHeadingButtonText != '' && rows.length > 0">
            <mds-button
              type="button"
              variation="secondary"
              icon-right="plus"
              @click="handleSingleCardDropdown()"
              id="advance-screen-popover"
              >{{ singleHeadingButtonText }}</mds-button
            >
            <mds-popover
              v-if="singleHeadingOptions.length > 1"
              triggered-by="advance-screen-popover"
              width="200px"
              v-model="toggle"
              :position="['bottom-right']"
            >
              <mds-list-group
                no-rules
                style="max-height: 150px; overflow-y: auto"
              >
                <mds-list-group-item
                  @click.native="GridSelectionChange(value)"
                  :key="index"
                  v-for="(value, index) of singleHeadingOptions"
                >
                  <span>
                    {{ value.value }}
                  </span>
                </mds-list-group-item>
              </mds-list-group>
            </mds-popover>
          </div>
        </template>
      </mds-row>

      <div v-if="rows.length == 0" class="cf-blank-searchResults">
        <mds-empty-state
          size="medium"
          :title="emptyGridData.title"
          :message="emptyGridData.message"
        >
          <template #mds-empty-state-icon>
            <img
              alt="dollor"
              src="../../assets/icons/dollar.svg"
              role="presentation"
            />
          </template>
          <template #mds-empty-state-actions>
            <mds-button
              type="button"
              variation="secondary"
              icon-right="plus"
              @click="handleSingleCardDropdown()"
              id="advance-screen-popover1"
              >{{ singleHeadingButtonText }}</mds-button
            >
            <mds-popover
              v-if="singleHeadingOptions.length > 1"
              triggered-by="advance-screen-popover1"
              width="200px"
              v-model="toggle"
              :position="['right-center']"
            >
              <mds-list-group
                no-rules
                style="max-height: 150px; overflow-y: auto"
              >
                <mds-list-group-item
                  @click.native="GridSelectionChange(value)"
                  :key="index"
                  v-for="(value, index) of singleHeadingOptions"
                >
                  <span>
                    {{ value.value }}
                  </span>
                </mds-list-group-item>
              </mds-list-group>
            </mds-popover>
          </template>
        </mds-empty-state>
      </div>
      <div
        class="groupWrap"
        :key="i"
        v-for="(d, i) in singleHeadingOptionsfilter"
        :style="i == 0 ? 'margin-top:0px' : ''"
      >
        <div class="group">
          <mds-row>
            <template>
              <div class="cf-heading-align-subheading cf-headingSingle">
                {{ d.value }}
              </div>
            </template>
          </mds-row>
          <mds-row>
            <div style="padding: 0px 10px">
              <mds-table class="cf-tableCutomStyles">
                <mds-thead>
                  <mds-th
                    :sorted="header.isSortable ? -1 : 0"
                    :sortable="header.isSortable"
                    v-for="(header, index) in filterHeaders(d.key)"
                    :key="'header-' + index"
                    :style="header.style"
                    :rightAligned="header.isSortable"
                  >
                    <div
                      class="table-headLables"
                      v-if="
                        singleHeadingOptionsfilter[i].showDateLabel &&
                        header.text
                      "
                    >
                      {{ header.text }}
                    </div>
                    <div class="table-headLables" v-else-if="header.label">
                      {{ header.label }}
                    </div>
                  </mds-th>
                </mds-thead>
                <mds-tbody>
                  <mds-tr
                    v-for="(row, ind) in dynamicrows(d.key)"
                    :key="'row-' + ind"
                  >
                    <mds-td
                      v-for="(header, index) in filterHeaders(d.key)"
                      :key="'header-' + index"
                      :style="header.style"
                    >
                      <template v-if="header.type === 'FormatInput'">
                        <adl-input-format
                          :isDisabled="row[header.key].disable"
                          autocomplete="off"
                          :name="header.key"
                          :label="''"
                          :value="row[header.key].value"
                          :ref="header.key + getGroupID(row) + ind"
                          v-model="row[header.key].value"
                          :isAllowOnlyNumber="header.isAllowOnlyNumber"
                          :AllowOnlyDecimalTill="header.AllowOnlyDecimalTill"
                          :currencyFormat="header.currencyFormat"
                          :appendText="header.appendText"
                          :microcopy-below="row[header.key].microcopyBelow"
                          @editableRowButtonClick="
                            $emit(
                              'editableRowButtonClick',
                              header.callBackMethod,
                              row[header.key].value,
                              ind
                            )
                          "
                          @change="onChange($event, header.key, ind)"
                          :maxlength="header.length"
                          :maxvalue="header.max"
                          :minvalue="header.min ? header.min : 0"
                          :isError="row[header.key].IsError"
                          :errorText="row[header.key].ErrorText"
                        ></adl-input-format>
                      </template>
                      <template v-if="header.type === 'Input'">
                        <mds-input
                          v-bind:disabled="row[header.key].disable"
                          autocomplete="off"
                          :name="header.key"
                          :label="''"
                          :value="row[header.key].value"
                          :ref="header.key + getGroupID(row) + ind"
                          v-model="row[header.key].value"
                          @keydown="
                            handleTabKey(
                              $event,
                              header.isAllowToAddNextRow,
                              ind,
                              getGroupID(row)
                            )
                          "
                          @change="onChange($event, header.key, ind)"
                          :error="row[header.key].IsError"
                          :errorText="row[header.key].ErrorText"
                          :maxlength="header.length"
                        ></mds-input>
                      </template>

                      <template v-else-if="header.type === 'Dropdown'">
                        <mds-select
                          v-bind:disabled="row[header.key].disable"
                          :name="header.key"
                          :label="''"
                          :ref="header.key + getGroupID(row) + ind"
                          :options="header.options"
                          :value="row[header.key].value"
                          v-model="row[header.key].value"
                          @change="onChange($event, header.key, ind, row)"
                          @keydown="
                            handleTabKey(
                              $event,
                              header.isAllowToAddNextRow,
                              ind,
                              getGroupID(row)
                            )
                          "
                          :error="row[header.key].IsError"
                          :errorText="row[header.key].ErrorText"
                        >
                        </mds-select>
                      </template>
                      <template v-else-if="header.type === 'Combobox'">
                        <combo-box-select
                          :name="header.key"
                          :label="''"
                          :ref="header.key + getGroupID(row) + ind"
                          :dataset="header.options"
                          v-model="row[header.key].value"
                          :value="row[header.key].value"
                          @keydown="
                            handleTabKey(
                              $event,
                              header.isAllowToAddNextRow,
                              ind,
                              getGroupID(row)
                            )
                          "
                          @change="onChange($event, header.key, ind)"
                          :error="row[header.key].IsError"
                          :errorText="row[header.key].ErrorText"
                        >
                        </combo-box-select>
                      </template>

                      <!-- <template v-else-if="header.type === 'MonthPicker'">
                        <div style="position: relative; display: block">
                          <adl-month-picker
                            :typing="header.typing"
                            :displayTop="header.displayTop"
                            v-bind:disabled="row[header.key].disable"
                            :name="header.key"
                            :isShowFocus="row[header.key].isShowFocus"
                            :label="''"
                            :ref="header.key + getGroupID(row) + ind"
                            :dataset="header.options"
                            v-model="row[header.key].value"
                            :value="row[header.key].value"
                            @keydown="
                              handleTabKey(
                                $event,
                                header.isAllowToAddNextRow,
                                ind,
                                getGroupID(row)
                              )
                            "
                            @input="onChange($event, header.key, ind)"
                            :error="row[header.key].IsError"
                            :errorText="row[header.key].ErrorText"
                            :minYear="header.minYear"
                            :yearTerm="header.yearTerm"
                          >
                          </adl-month-picker>
                        </div>
                      </template> -->

                      <template
                        v-else-if="
                          header.type === 'MonthPicker' ||
                          header.type === 'MonthPickerSelect'
                        "
                      >
                        <div style="position: relative; display: block">
                          <adl-month-picker-select
                            :typing="header.typing"
                            :showLeft="header.showLeft"
                            :displayTop="header.displayTop"
                            v-bind:disabled="row[header.key].disable"
                            :name="header.key"
                            :isShowFocus="row[header.key].isShowFocus"
                            :label="''"
                            :ref="header.key + getGroupID(row) + ind"
                            :dataset="header.options"
                            v-model="row[header.key].value"
                            :value="row[header.key].value"
                            :microcopyBelow="row[header.key].text"
                            @keydown="
                              handleTabKey(
                                $event,
                                header.isAllowToAddNextRow,
                                ind,
                                getGroupID(row)
                              )
                            "
                            :error="row[header.key].IsError"
                            :errorText="row[header.key].ErrorText"
                            :minYear="header.minYear"
                            :yearTerm="header.yearTerm"
                            :listdata="header.listdata"
                            :selectvalue="header.selectvalue"
                          >
                          </adl-month-picker-select>
                        </div>
                      </template>

                      <template v-else-if="header.type === 'Icon'">
                        <mds-button-container style="padding-top: 6px">
                          <template v-for="i in header.data">
                            <img
                              height="18px"
                              :key="i"
                              src="../../assets/icons/checkicon.svg"
                              v-if="
                                i.type == 'svg' &&
                                !checkerrors(row) &&
                                !row.newRow
                              "
                            />
                            <mds-button
                              v-if="i.type == 'icon'"
                              style="margin-left: 6px"
                              :key="i"
                              @click="removeField(row, i.action)"
                              type="button"
                              variation="icon-only"
                              :icon="i.icon"
                              size="small"
                            >
                              {{ i.iconText }}</mds-button
                            >
                          </template>
                        </mds-button-container>
                      </template>
                    </mds-td>
                  </mds-tr>
                </mds-tbody>
              </mds-table>
            </div>
          </mds-row>

          <mds-row>
            <template
              v-if="isShowHint == true && geterrorlist(d.key).length > 0"
            >
              <mds-button
                v-for="i in geterrorlist(d.key)"
                :key="i"
                variation="flat"
                :icon="infoError ? 'alert' : 'info-circle'"
                :class="infoError ? 'cf-alignment red' : 'cf-alignment'"
              >
                {{ i }}
              </mds-button>
            </template>
          </mds-row>
          <mds-row>
            <template v-if="rowTemplateButton.length > 0">
              <mds-col v-for="button in rowTemplateButton" :key="button">
                <mds-button
                  :variation="button.variation"
                  :icon-right="button.icon"
                  :ref="button.key"
                  style="margin-top: 10px"
                  @click="
                    $emit(
                      'rowTemplateButtonClick',
                      button.callBackMethod,
                      d,
                      dynamicrows(d.key).length
                    )
                  "
                >
                  {{ button.text }}
                </mds-button>
              </mds-col>
            </template>
          </mds-row>
          <nav v-for="b in rowOuterButton" :key="b">
            <mds-button
              class="groupWrapCTA"
              @click="$emit('OuterRowButtonClick', b.callBackMethod, d.key)"
              type="button"
              :variation="b.variation"
              :icon="b.icon"
              :size="b.size"
            >
            </mds-button>
          </nav>
        </div>
      </div>
    </mds-layout-grid>
    <slot name="message"></slot>

    <template v-if="rows.length > 0">
      <mds-layout-grid>
        <mds-row class="cf-Button-align">
          <mds-col :cols="8">
            <mds-button-container>
              <mds-button
                v-for="button in gridButtonTemplate"
                :key="button.key"
                :variation="button.variation"
                :icon="button.icon"
                :size="button.size"
                :disabled="button.isdisabled"
                :id="button.key"
                :ref="button.key"
                @click="
                  $emit('editableRowButtonClick', button.callBackMethod, rows)
                "
              >
                {{ button.text }}
              </mds-button>
            </mds-button-container>
          </mds-col>
        </mds-row>
      </mds-layout-grid>
    </template>
  </div>
</template>

<script>
import Vue from "vue";
import MdsInput from "@mds/input";
import MdsPopover from "@mds/popover";
import MdsSelect from "@mds/select";
import { MdsButton, MdsButtonContainer } from "@mds/button";
import AdlInputFormat from "../custom/input-format/InputFormat.vue";
import { MdsLayoutGrid, MdsRow, MdsCol } from "@mds/layout-grid";

import ComboBoxSelect from "./combobox-select.vue";
import RangeDirective from "../../directives/range-directive";
// import MdsSection from '@mds/section'
import { MdsListGroup, MdsListGroupItem } from "@mds/list-group";

import AdlMonthPickerSelect from "../custom/MonthPickerSelect/MonthPickerSelect.vue";

import MdsEmptyState from "@mds/empty-state";
import {
  MdsTable,
  MdsThead,
  MdsTh,
  MdsTbody,
  MdsTr,
  MdsTd,
} from "@mds/data-table";

export default Vue.extend({
  name: "AdlGrid",
  components: {
    MdsButton,
    MdsButtonContainer,
    AdlInputFormat,
    MdsLayoutGrid,
    MdsRow,
    MdsCol,
    MdsSelect,
    MdsInput,

    ComboBoxSelect,
    MdsPopover,
    // MdsSection,
    MdsListGroup,
    MdsListGroupItem,

    AdlMonthPickerSelect,
    MdsTable,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
    MdsEmptyState,
  },
  props: {
    emptyGridData: {
      type: Object,
    },
    rowOuterButton: {
      type: Array,
    },
    addButtonText: {
      type: String,
    },
    infoError: {
      type: Boolean,
      default: false,
    },
    focusElementName: {
      type: String,
    },
    updateButtonText: {
      type: String,
    },
    infoText: {
      type: Array,
    },
    headers: {
      type: Array,
    },
    gridButtonTemplate: {
      type: Array,
    },
    rowTemplateButton: {
      type: Array,
    },
    rows: {
      type: Array,
    },
    singleHeading: {
      type: String,
    },
    singleHeadingOptions: {
      type: Array,
    },
    singleHeadingButtonText: {
      type: String,
    },
    isShowHint: {
      type: Boolean,
    },
    gridSplitId: {
      type: String,
    },
  },
  data() {
    return {
      sortType: "desc",
      fields: Object.assign({}, this.rows),
      selectedIndex: -1,
      toggle: false,
    };
  },
  created() {},
  computed: {
    singleHeadingOptionsfilter() {
      let headingArray = Object.assign([], this.singleHeadingOptions);
      if (this.gridSplitId == "" && this.rows.length > 0) {
        return headingArray;
      }
      let filteredArray = [];
      if (this.rows.length > 0) {
        for (let i = 0; i < headingArray.length; i++) {
          if (
            this.rows.filter(
              (s) => s[this.gridSplitId].value == headingArray[i].key
            ).length > 0
          ) {
            filteredArray.push(headingArray[i]);
          }
        }
      }
      return filteredArray;
    },
  },
  mounted() {
    let errorElementName = this.errorElementName();
    if (errorElementName && this.$refs[errorElementName]) {
      this.$nextTick(() => {
        this.$refs[errorElementName][0].$el.focus();
      });
    }
  },

  watch: {
    focusElementName: {
      handler: function (val) {
        if (val != "" && this.$refs[val]) {
          this.$nextTick(() => {
            this.$refs[val][0].$el.focus();
          });
        }
      },
    },
  },

  directives: {
    maxvalue: RangeDirective.maxvalue,
    maxlength: RangeDirective.maxlength,
  },
  methods: {
    getGroupID(row) {
      if (this.gridSplitId == "") return 1;
      else return row[this.gridSplitId].value;
    },

    checkerrors(row) {
      let haserror = false;

      let subtype = this.gridSplitId == "" ? 1 : row[this.gridSplitId].value;
      let filteredheaders = this.singleHeadingOptions.filter(
        (x) => x.key == subtype
      )[0].fields;
      for (let i = 0; i < filteredheaders.length; i++) {
        if (row[filteredheaders[i]].IsError) {
          haserror = true;
          break;
        } else {
          continue;
        }
      }

      return haserror;
    },
    geterrorlist(typeid) {
      let messages = this.infoText;
      let fiileredmessages = messages
        .filter((x) => x.type == typeid)
        .map((t) => {
          let p = "";
          p = t.error;
          return p;
        });
      return fiileredmessages;
    },
    handleSingleCardDropdown() {
      if (this.singleHeadingOptions.length > 1) {
        this.toggle = !this.toggle;
      } else {
        this.GridSelectionChange(this.singleHeadingOptions[0]);
      }
    },
    dynamicrows(key) {
      let cardSplitId = this.gridSplitId;
      let currentRows = Object.assign([], this.rows);
      if (cardSplitId == "") {
        return currentRows;
      } else {
        return currentRows.filter((s) => s[cardSplitId].value == key);
      }
    },
    GridSelectionChange(value) {
      this.toggle = false;
      this.$emit("GridSelectionChange", value);
    },
    filterHeaders(Type) {
      let heasersdata = Object.assign([], this.headers);
      let repaymenttypes = this.singleHeadingOptions.filter(
        (data) => data.key == Type
      )[0].fields;
      let filterHeaders = [];
      if (this.rows.length > 0) {
        for (let i = 0; i < heasersdata.length; i++) {
          if (
            repaymenttypes.filter((d) => d == heasersdata[i].key).length > 0 ||
            heasersdata[i].type == "Icon"
          ) {
            filterHeaders.push(heasersdata[i]);
          }
        }
      }
      return filterHeaders;
    },
    errorElementName() {
      let element;
      for (let i = 0; i < this.rows.length; i++) {
        for (let j = 0; j < this.headers.length; j++) {
          element = this.rows[i][this.headers[j].key];
          if (element && element.IsError) {
            return this.headers[j].key + i;
          }
        }
      }
    },
    handleTabKey(event, isAllowToAddNextRow, index, subtypeid) {
      if (event.key === "Tab" && isAllowToAddNextRow) {
        this.addField(index, subtypeid);
      }
    },
    addField(index, subtypeid) {
      this.$emit("addRow", index, subtypeid);
    },

    removeField(fieldType, type) {
      if (type == "delete") {
        let currentRowsindex = this.rows.indexOf(fieldType);
        this.rows.splice(currentRowsindex, 1);
        this.$emit("removeRow", type);
      }
    },
    onChange(event, key, index, row) {
      let data = {
        event: event,
        key: key,
        index: index,
        row: row,
      };

      this.$emit("onChange", data);
    },

    handleSortEvent(colIndex, colName, type, gridSplitId = "", key = 0) {
      this.selectedIndex = colIndex;

      let filteredRows = Object.assign([], this.rows);
      if (gridSplitId != "") {
        filteredRows = filteredRows.filter((r) => (r[gridSplitId].key = key));
      }
      if (type == "asc") {
        this.sortType = type;
        filteredRows.sort((a, b) => {
          return a[colName] >= b[colName] ? 1 : -1;
        });
      } else {
        this.sortType = type;
        filteredRows.sort((a, b) => {
          return a[colName] < b[colName] ? 1 : -1;
        });
      }
    },
  },
});
</script>
<style lang="scss">
.cf-blank-searchResults {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  width: 320px;
  height: 271px;
  margin: 0 auto;
  // margin-top: 32px;
}

.cf-fields + .cf-fields {
  margin-top: 14px !important;
}

.cf-fields .cf-fields-single:nth-child(2n) {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.cf-alignment {
  margin-top: 10px !important;
  margin-left: 13px;
}

.red span {
  fill: red !important;
  stroke: red !important;
}

.cf-Icon-align {
  margin-top: 4px !important;
}

.cf-Button-align {
  // margin-top: 10px !important;
  margin-top: $mds-space-2-x !important;
  margin-bottom: $mds-space-2-x !important;
}

.cf-label-align {
  margin-bottom: 14px;
}

.cf-sort-align {
  margin-left: -11px;
}

.cf-sort-wrap .cf-sort-up {
  position: relative;
  left: 8px;
}

.cf-sort-wrap > span > svg {
  fill: #ababab;
}

.cf-sort-wrap > span.active > svg {
  fill: #1e1e1e;
}

.cf-heading-align {
  font-weight: 600;
  color: #1e1e1e;
  margin-bottom: 4px !important;
}

.cf-heading-align-subheading {
  font-weight: 300;
  color: #1e1e1e;
  margin-bottom: 4px !important;
}
.cf-single-subheading {
  font-weight: 400;
  color: #1e1e1e;
  margin-bottom: 12px !important;
  margin-left: -8px;
}

.cf-AdvanceSettings-Wrap {
  /* padding: 0px 4px; */
  margin-top: $mds-space-3-x;
}

.cf-headingSingle {
  margin-bottom: 16px !important;
  padding-left: 16px;
  font-size: 18px;
  margin-right: 10px;
}

.mds-popover_CashFlow {
  z-index: 999 !important;
}
.groupWrap:first-child {
  margin-top: 0px !important;
}
.groupWrap {
  // padding-right: 48px;
  margin-top: 24px;
  .group {
    border: 1px solid #ccc;
    padding: 12px;
    border-radius: 8px;
    background-color: #fff;

    position: relative;
  }

  .groupWrapCTA {
    position: absolute;
    right: -28px;
    top: 50%;
  }
}

.cf-tableCutomStyles {
  .mds-th--sortable {
    border: none !important;

    .mds-th__inner {
      border: none !important;
      background-color: red;
    }
  }

  th {
    [class^="mds-th__inner"] {
      border: none !important;
      margin-bottom: 0px;
    }

    .table-headLables {
      font-size: 16px;
      line-height: 21px;
      font-weight: 600;
      color: #1e1e1e;
    }
  }

  td {
    border: none !important;
    padding-bottom: 6px !important;

    &:first-child {
      padding-left: 8px !important;
    }

    &:last-child {
      padding-right: 8px !important;
    }

    &:nth-child(2n) {
      padding-left: 4px !important;
      padding-right: 4px !important;
    }
  }

  th {
    &:first-child {
      padding-left: 8px !important;
    }

    &:last-child {
      padding-right: 8px !important;
    }

    &:nth-child(2n) {
      padding-left: 4px !important;
      padding-right: 4px !important;
    }
  }
}
</style>
